import React from 'react';

import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import CustomSelect from "./CustomSelect";

class ItemMultiSelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            itemsMnemo: "all",
            items: this.props.items
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.items !== this.props.items && this.props.items && this.props.items.length > 0) {
            this.props.onItemsChange(this.props.items.map(item => { return item.value }));
        }
    }

    render() {
        return (
            <div className="mt-3">
                <label>{this.props.caption}</label>

                <div class="list-group list-group-horizontal-md">
                    <button className={"list-group-item list-group-item-action" + (this.state.itemsMnemo === "all" ? " active" : "")}
                        onClick={() => {

                            this.setState({
                                items: this.props.items,
                                itemsMnemo: "all"
                            },
                                this.props.onItemsChange(
                                    this.props.items.map((item) => {
                                        return item.value;
                                    })
                                )
                            )
                        }}>
                        Все
                    </button>

                    <div className={"list-group-item list-group-item-action" + (this.state.itemsMnemo === "custom" ? " active" : "")}
                        style={{ cursor: "pointer" }}
                    >
                        <div
                            onClick={() => this.setState({
                                items: null,
                                itemsMnemo: "custom"
                            },
                                this.props.onItemsChange([])
                            )}
                        >
                            Произвольно...
                        </div>
                        <div>
                            {
                                this.state.itemsMnemo === "custom" &&
                                <div className="mt-3">
                                    <CustomSelect
                                        isMulti
                                        isColored={this.props.isColored}
                                        options={this.props.items}
                                        onChange={(value) => {
                                            this.props.onItemsChange(value.map(item => { return item.value }))
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ItemMultiSelector;